import { Injectable } from "@angular/core";
import { EditBankDialogComponent } from "./edit-bank-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { APSMaster } from "src/app/models";
@Injectable({
  providedIn: "root"
})
export class EditBankDialogService
{
  constructor(public dialog: MatDialog) { }
  public openDialog(bank: APSMaster): MatDialogRef<EditBankDialogComponent>
  {
    const dialogRef = this.dialog.open(EditBankDialogComponent, {
      panelClass: "form-field-less-than-180",
      width: "400px",
      data: bank,
      disableClose: true
    });
    return dialogRef;
  }
}